export default __webpack_public_path__ + "static/media/ic_warning.dd5044f6.svg";